import styles from './index.module.scss';
import IconButton from "@/app/_components/Shared/IconButton";

export default function Alert({
    children,
    buttonText,
    buttonOnClick,
   }) {
    return (
        <div className={styles.alert}>
            <div className={styles.text}>
                {children}
            </div>
            {buttonText && (
                <IconButton
                    onClick={buttonOnClick}
                    className={styles.button}
                >
                    {buttonText}
                </IconButton>
            )}
        </div>
    );
}